<template>
  <div class="attendance-gallery-container">
    <attendance-gallery-filters
      :loading="loading"
      @filter-change="handleFilterChange"
    />
    
    <attendance-gallery-grid
      :attendances="resources"
      :loading="loading"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AttendanceGalleryFilters from './components/AttendanceGalleryFilters.vue'
import AttendanceGalleryGrid from './components/AttendanceGalleryGrid.vue'

export default {
  name: 'attendance-gallery',
  components: {
    AttendanceGalleryFilters,
    AttendanceGalleryGrid
  },
  data() {
    return {
      loading: false,
      resources: {}
    }
  },
  computed: {
    ...mapState('report/attendanceGallery', [
      'filters'
    ])
  },
  methods: {
    ...mapActions('report/attendanceGallery', [
      'getOrgChartStructure',
      'setFilters',
      'fetch'
    ]),
    
    async handleFilterChange(filters) {
      this.loading = true
      try {
        await this.setFilters(filters)
        const response = await this.fetch()
        this.resources = response || {}
      } catch (error) {
        this.resources = {}
        this.$Notice.error({
          title: 'ATTENDANCE GALLERY',
          desc: error.message || 'Failed to load attendance data'
        })
      } finally {
        this.loading = false
      }
    },

    async initialize() {
      this.loading = true
      try {
        await this.getOrgChartStructure()
      } catch (error) {
        console.error('Failed to load initial data:', error)
        this.$Notice.error({
          title: 'INITIALIZATION ERROR',
          desc: 'Failed to load organization structure'
        })
      } finally {
        this.loading = false
      }
    }
  },
  
  beforeRouteLeave(to, from, next) {
    this.$store.commit('report/attendanceGallery/RESET_STATE')
    next()
  },
  
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initialize()
    })
  }
}
</script>

<style scoped lang="scss">
.attendance-gallery-container {
  min-height: 100vh;
  background: #f0f2f5;
  padding: 0 16px 16px 16px;
}

::v-deep {
  .viewer-backdrop {
    background-color: rgba(0, 0, 0, 0.92);
  }
  
  .viewer-container {
    z-index: 9999;
  }
  
  .viewer-canvas > img {
    max-width: 90%;
    max-height: 90%;
  }
  
  .viewer-toolbar {
    border-radius: 8px;
    padding: 8px;
    
    > li {
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 6px;
      margin: 0 4px;
      transition: all 0.2s ease;
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.25);
        transform: scale(1.1);
      }
      
      &::before {
        color: white;
      }
    }
  }
  
  .viewer-title {
    font-weight: 600;
    padding: 12px 20px;
    border-radius: 8px;
    backdrop-filter: blur(10px);
  }
  
  .viewer-button {
    border-radius: 50%;
    width: 48px;
    height: 48px;
    transition: all 0.2s ease;
    
    &:hover {
      transform: scale(1.1);
    }
    
    &::before {
      color: white;
    }
  }
  
  .viewer-navbar {
    border-radius: 8px;
    padding: 8px;
    
    > ul > li {
      border-radius: 6px;
      overflow: hidden;
      border: 2px solid transparent;
      transition: all 0.2s ease;
      
      &.viewer-active,
      &:hover {
        border-color: white;
      }
    }
  }
  
  .viewer-loading {
    &::after {
      border-color: #667eea transparent transparent;
    }
  }
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
}
</style>
